import React, { useEffect, useState } from "react";
import "../styles/SupportDocs.css";
import { fetchSupportDocumentLinks } from "../helpers/contentfulHelper";
import { FaDownload } from "react-icons/fa";
import { useTranslation } from "../context/TranslationContext";

const SupportDocs = () => {
  const [supportDocs, setSupportDocs] = useState([]);
  const { language, t } = useTranslation();

  useEffect(() => {
    const loadSupportDocs = async () => {
      const items = await fetchSupportDocumentLinks();
      setSupportDocs(items);
    };

    loadSupportDocs();
  }, []);

  return (
    <div className="support-docs-container">
      <div className="heading mb-20">{t("support_documents_heading")}</div>
      <div className="support-docs-grid">
        {supportDocs.length === 0 ? (
          <p>{t("support_documents_none")}</p>
        ) : (
          supportDocs.map((item) => {
            const title =
              language === "pt"
                ? item.fields.namePt || item.fields.name
                : item.fields.name;

            return (
              <div key={item.sys.id} className="support-docs-card">
                <FaDownload className="icon" />
                <a
                  href={item.fields.url}
                  className="support-docs-title"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {title}
                  <span className="support-docs-date">
                    {item.sys.createdAt &&
                      `(${new Date(item.sys.createdAt).toLocaleDateString(
                        language,
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        },
                      )})`}
                  </span>
                </a>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SupportDocs;
